import { combineReducers } from 'redux';
import idList from './id-list';
import metadata from './metadata';

export default combineReducers({
  idList,
  metadata,
});



// WEBPACK FOOTER //
// ./app/reducers/followers/index.js